export const EKYC_LIST_FETCH = 'ekyc/EKYC_LIST_FETCH';
export const EKYC_LIST_SUCCESS = 'ekyc/EKYC_LIST_SUCCESS';
export const EKYC_INFO_FETCH = 'ekyc/EKYC_INFO_FETCH';
export const EKYC_INFO_SUCCESS = 'ekyc/EKYC_INFO_SUCCESS';

export const EKYC_KYC_FILE_RETRIEVE_FETCH = 'ekyc/EKYC_KYC_FILE_RETRIEVE_FETCH';
export const EKYC_KYC_FILE_RETRIEVE_SUCCESS = 'ekyc/EKYC_KYC_FILE_RETRIEVE_SUCCESS';
